// Local Deps
import { makeGraphQLRequest } from '../utils/requestUtils';

export async function requestOrganization(organization) {
  // Format Mutation
  const query = `mutation requestOrg($org: CreateOrganizationInput) { requestOrganization (organization: $org) 
    { id
      name
      email
      iconStatus
      cageCode } }`;

  // Variables
  const variables = {
    org: organization,
  };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function UpdateOrganization(Organization) {
  const orgCopy = { ...Organization };
  delete orgCopy.admins;
  delete orgCopy.users;
  // Format Query
  const query = `mutation updateOrganization($organization: EditOrganizationInput) { updateOrganization (organization: $organization) { id, name, email, iconStatus, cageCode } }`;
  // Variables
  const variables = { organization: orgCopy };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

// export async function requestUpdateOrganization(Organization) {
//   // Format Query
//   const query = `mutation requestUpdateOrganization($org: EditOrganizationInput) { requestUpdateOrganization (organization: $org) { id, name, email, iconStatus, cageCode } }`;

//   // Variables
//   const variables = { org: Organization };

//   const response = await makeGraphQLRequest({
//     query,
//     variables,
//   });
//   return response;
// }

export default {
  // requestUpdateOrganization,
  requestOrganization,
};

export async function createOrganization(formValues) {
  const query = ` 
        mutation createOrg($org: CreateOrganizationInput) { createOrganization (organization: $org) 
            { id, name, email, iconStatus, cageCode 
            } 
        }
        `;
  try {
    const organization = await makeGraphQLRequest({
      query,
      variables: { org: formValues },
    });
    return organization;
  } catch (error) {
    return { Errors: 'You done messed up A-A-Ron' };
  }
}



// WEBPACK FOOTER //
// ./src/graphql/organization.js